var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.582,
    height: 26.582,
    viewBox: "0 0 26.582 26.582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-filter",
    "data-name": "Icon awesome-filter",
    d: "M25.335,0H1.247A1.247,1.247,0,0,0,.366,2.127l9.6,9.6v10.7a1.246,1.246,0,0,0,.531,1.021l4.153,2.906a1.247,1.247,0,0,0,1.961-1.021V11.73l9.6-9.6A1.247,1.247,0,0,0,25.335,0Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.9e8ba9e043b929ea882d002f6965cb13.svg";
export { ForwardRef as ReactComponent };